import { adminRoutes, allSections } from '../../navigation/adminRoutes';

/**
 * Generate navigation commands from adminRoutes
 * Each section becomes a navigable command
 */
export const generateNavigationCommands = (canAccessSection) => {
  return allSections
    .filter((section) => canAccessSection(section.id))
    .map((section) => {
      // Find category for this section
      const category = Object.entries(adminRoutes).find(([, cat]) =>
        cat.sections.some((s) => s.id === section.id)
      );
      const categoryLabel = category ? category[1].label : '';

      return {
        id: `nav-${section.id}`,
        type: 'navigation',
        label: section.label,
        description: section.description,
        category: categoryLabel,
        icon: section.icon,
        path: section.path,
        keywords: [
          section.label.toLowerCase(),
          section.description?.toLowerCase() || '',
          categoryLabel.toLowerCase(),
          section.id,
        ].filter(Boolean),
      };
    });
};
